module.exports = __webpack_public_path__ + "static/media/right-arrow.ce696383.svg";